import { pdfjs } from 'react-pdf'

declare const __PDF_WORKER_URL__: string

// Must be called (not just imported for side effects) — @paintscout/ui sets
// `sideEffects: false`, so production builds tree-shake bare side-effect imports,
// leaving react-pdf's default workerSrc ('pdf.worker.js') pointing at a URL that
// doesn't exist on deployed environments.
export default function configurePdfWorker(): void {
  pdfjs.GlobalWorkerOptions.workerSrc =
    typeof __PDF_WORKER_URL__ !== 'undefined' && __PDF_WORKER_URL__
      ? __PDF_WORKER_URL__
      : `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
}
